import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { v4 as uuidv4} from 'uuid';

import {
  openModal,
  closeModal
} from 'shared/actions/modalActions';

const styles = theme => ({
  modal: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    transition: 'transform 0.5s ease-out, opacity 0.5s',
    opacity: 0,
    zIndex: 9998,
    background: 'none',
    overflowX: 'hidden',
    overflowY: 'scroll',
    pointerEvents: 'none',
    display: 'none',
  },
  disableScrollbar: {
    overflowY: 'hidden !important'
  },
  scroller: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
});

class Modal extends React.Component {
  constructor(props) {
    super(props)

    this.node = createRef();
    this.opened = false;
    this.id = uuidv4();

    this.state = {
      disabled: false
    }
  }

  componentDidUpdate() {
    if (!this.props.isOpen) {
      this.opened = false;
    }

    if ((!this.opened || this.props.forceOpen) && this.props.isOpen) {
      setTimeout(() => this.open(), 100);
    }
  }

  open() {
    document.body.style.overflowY = 'hidden';

    let e = this.node.current;
    e.style.display = 'block';
    e.style.pointerEvents = 'auto';
    window.getComputedStyle(e).getPropertyValue('top'); // force reflow to prepare transition
    e.style.opacity = 1;

    this.opened = true;
    this.props.openModal(this.id);

    // hotfix
    window.previousModal = window.currentModal;
    window.currentModal = this;
    window.modals = window.modals || [];
    window.modals.push(this);

    if (this.node.current) {
      // needs a delay or it leaves the cover moment lagging
      setTimeout(() => {
        this.node.current.style.transform = `translate(0, 0)`;
      }, 500);
    }
  }

  close() {
    // prevents infinite loop.
    // I haven't figured out how this happens
    if (!this.props.isOpen) {
      return;
    }

    // hotfix
    let node = document.getElementById('modal-' + this.id);
    if (node) {
      // only slow down opacity (it's 0.5s when opening)
      node.style.transition = 'transform 0.5s ease-out, opacity 1s';
      window.getComputedStyle(node).getPropertyValue('top');

      node.style.transform = `translate(0, ${parseInt(window.innerHeight) + 100}px)`;
      node.style.opacity = 0;
    }

    setTimeout(() => {
      this.props.closeModal(this.id);
      this.props.close();
      this.opened = false;

      // reset transition speed for next open
      setTimeout(() => {
        if (node) {
          node.style.transition = 'transform 0.5s ease-out, opacity 0.5s';
          window.getComputedStyle(node).getPropertyValue('top');
        }
      }, 500);
    }, 500);

    window.currentModal = window.previousModal;
  }

  render() {
    if (this.props.isOpen || this.opened) {
      window.close = this.close.bind(this);

      const { classes } = this.props;

      let scrollbarClass = '';
      if (this.state.disabled || this.props.disableScrollbar) {
        scrollbarClass = classes.disableScrollbar;
      }

      //let background = this.props.background || '#fff';

      return (
        <div ref={this.node}
          id={`modal-${this.id}`}
          style={{
            pointerEvents: this.props.isOpen ? 'auto' : 'none',
            transition: this.props.transition,
            transform: `translate(0, ${this.opened ? 0 : parseInt(window.innerHeight) + 100}px)`
          }}
          className={`${classes.modal} ${scrollbarClass}`}>
          <div className={classes.scroller}>
            {React.Children.map(this.props.children, child => {
              return React.cloneElement(child, {
                scrollNode: this.node
              });
            })}
          </div>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => ({
  modals: state.modalReducer.modals
});

export default connect(mapStateToProps, { openModal, closeModal })(withStyles(styles, {withTheme: true})(Modal));
